import { REPORTS_VIEW_STORAGE_KEY, savedReportsViews } from '../constants/reportView';
import { useEffect, useState } from 'react';
import { fromJS } from 'immutable';
import { useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import ReportsTable from './ReportsTable';
import { ReportsGrid } from './ReportsGrid';
// @ts-expect-error Untyped import
import { setProperties } from '../lib/usageTracker';
import * as storage from 'reporting-data/lib/storage';
// @ts-expect-error Untyped import
import { selectTableData } from '../selectors/tableData';
// @ts-expect-error Untyped import
import { selectTableDataStatus } from '../selectors/tableData';
import AsyncReportsListSubHeader from './AsyncReportsListSubHeader';
import { requestStatusTypes } from '../constants/requestStatusTypes';
import { ReportsPaginator } from '../components/reportsView/ReportsPaginator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PREVIEW_LIMIT_OVERRIDE = 3;
export const ReportsViewContainer = ({
  isSearch = false,
  showPreview
}) => {
  const [reportsView, setReportsView] = useState(storage.get(REPORTS_VIEW_STORAGE_KEY) || savedReportsViews.TABLE);
  useEffect(() => {
    setProperties({
      screen: 'reports-list',
      subscreen: isSearch ? 'global-search' : 'reports-list',
      reportsListView: reportsView === savedReportsViews.TABLE ? 'table' : 'grid'
    });
    return () => {
      setProperties({
        subscreen: null,
        reportsListView: null
      });
    };
  }, [reportsView, isSearch]);
  const handleReportsViewChange = view => {
    storage.set(REPORTS_VIEW_STORAGE_KEY, view);
    setReportsView(view);
    //TODO: track event with standalone tracker
  };
  const reportListStatus = useSelector(selectTableDataStatus);
  const isLoading = reportListStatus === requestStatusTypes.PENDING;
  const error = reportListStatus === requestStatusTypes.FAILED;
  let reportsList = useSelector(selectTableData);
  if (showPreview) {
    reportsList = fromJS(reportsList.slice(0, PREVIEW_LIMIT_OVERRIDE));
  }
  const showPaginator = !showPreview && !isLoading && !reportsList.isEmpty() && !error;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "my-reports-container",
    children: [/*#__PURE__*/_jsx(AsyncReportsListSubHeader, {
      isSearch: isSearch,
      toggleProps: {
        reportsView,
        onViewChange: handleReportsViewChange
      }
    }), reportsView === savedReportsViews.GRID ? /*#__PURE__*/_jsx(ReportsGrid, {
      error: error,
      isSearch: isSearch,
      reports: reportsList,
      isLoading: isLoading
    }) : /*#__PURE__*/_jsx(ReportsTable, {
      showPreview: showPreview
    }), showPaginator && /*#__PURE__*/_jsx(ReportsPaginator, {})]
  });
};